import barba from "@barba/core";

const initVacancies = () => {
	const vacancyBlocks = document.querySelectorAll(
		".vacancies.no-entries:not(.is-inizialized)"
	);

	if (vacancyBlocks.length > 0) {
		function isPartiallyVisible(el) {
			var elementBoundary = el.getBoundingClientRect();
			var top = elementBoundary.top;
			var bottom = elementBoundary.bottom;
			var height = elementBoundary.height;

			return (
				top + height >= 0 &&
				height + window.innerHeight >= bottom &&
				elementBoundary.left + elementBoundary.width >= 0 &&
				elementBoundary.width <= window.innerWidth
			);
		}

		vacancyBlocks.forEach((block) => {
			block.classList.add("is-inizialized");
			document.addEventListener("scroll", () => {
				if (isPartiallyVisible(block)) {
					block.querySelector(".cross-out").style.animationPlayState =
						"running";
				}
			});
		});
	}
};

barba.hooks.beforeEnter(initVacancies);
document.addEventListener("DOMContentLoaded", initVacancies);
